import { createSlice } from '@reduxjs/toolkit'
import { requests } from 'api/index';
import URLS from 'api/endPoints';

const initialNotification = {
    SINGLEUSERJOURNEY:""
}

const slice = createSlice({
    name: "NOTIFICATION",
    initialState: {
        notification:initialNotification
    },
    reducers: {
         getUserSingleUserJourneyReducer: (state, action) => {
            state.notification.SINGLEUSERJOURNEY = action.payload
    }
    }
})

export default slice.reducer

const { getUserSingleUserJourneyReducer } = slice.actions



export const getUserSingleUserJourneyAction = (payload) => async (dispatch) => {
    try {
     
      let response = await requests.get(URLS.magUrl.getUserSingleuserJourney +'/'+ payload.HcId  )
      
     
        await dispatch(getUserSingleUserJourneyReducer(response))

        return await returnCode(response)
    } catch (error) {
        return console.error(error.message)
    }
}



function returnCode(response) {
  if (response.ResponseCode == 100 || 200) {
    return response;
  } else if (response.ResponseCode == 103) {
    return 103;
  } else {
    return 101;
  }
}
